const GraphQLQuery = require('app/graphql/Query');

class Table {
    defaultOptions() {
        return {
            'id': window.uniqid,
            'tableClass': '',
            '$container' : $('<div/>'),
            'length': 10,
            'showPagination': true,
            'footerContent': null,
            'footerBuilder': null,
            /* Example
             *    {
             *        'mode': "custom"|"full" default("full") //custom: redner must return <tr/>, full: render must only return content of full <tr><td>XXX</td></tr> ,
             *        'render': function(list){
             *            return "content";
             *        }
             *    }
             */
            
            'labelNoData': window.translate('noData'),

            'rowIdCallback': function(item){ return ''},
            'columns' : [],//column definition like DataTable.net
            /* Example
             *    {
             *        'name': 'statut',
             *        'label': 'Statut',
             *        'class': ?'col-statut',
             *        'ordered': ?true|false,
             *        'orderType': ?'statut',
             *        'orderDir': ?'DESC',
             *        'render': function(item,col){
             *            return "";
             *        }
             *    }
            */
            'data': null,//raw data list
            'hasEdges' : true,
            'graphQL': null,
            /* Example
             * {
             *      'queryType': "restaurants",
             *      'parameters': Object as app/graphql/Query expect it or Function returning an Object as app/graphql/Query expect it
             *      'fields': []//see app/graphql/Query
             *      
             * }
             */

            'onInitialize': function(){},
            'onLoadStart': function(){},
            'onLoadEnd': function(){},
            'onLoadComplete': function(data){},
            'onLoadFail': function(message){},
            'onDrawn': function(){},

            'onDrawLine': function($line,item,index){},//allow to do stuff on each $line

            'preprocessData': function(data,list){return data;},
            'getDataFromRawData': function(raw,list){return raw;}
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.onLoadComplete = this.onLoadComplete.bind(this);
        this.onLoadFail = this.onLoadFail.bind(this);
        this.onLoadStart = this.onLoadStart.bind(this);
        this.onLoadEnd = this.onLoadEnd.bind(this);

        this.$container = this.settings.$container;

        this.length = parseInt(this.settings.length);
        this.first = null;
        this.last = null;
        this.after = null;
        this.before = null;
        this.orderBy = null;
        this.orderDir = null;
        this.firstCursor = null;

        this.query = null;

        this.data = this.settings.data;

        this.isLoading = false;

        this.initialize();
    }

    initialize() {

        if(this.settings.onInitialize){
            this.settings.onInitialize();
        }

        this.$container
        .html('')
        .append(this.buildTable());
        if(this.isGraphQLData()){
            this.initializeWithGraphQL();
        }else if(this.hasData()){
            this.initializeWithRawData();
        }else{
            window.notify("TableList cannot initialize without data or data retrieval method","error");
        }
    }

    buildTable(){

        this.$table = $('<table/>')
        .attr('id',this.settings.id)
        .addClass('list-table')
        .addClass(this.settings.tableClass);

        this.$tableHead = $('<thead/>')
        .addClass('list-table-head');

        this.$tableBody = $('<tbody/>')
        .addClass('list-table-body');

        this.$tableFoot = $('<tfoot/>')
        .addClass('list-table-foot');

        this.$table
        .append(this.$tableHead)
        .append(this.$tableBody)
        .append(this.$tableFoot);

        this.buildHeader();

        return this.$table;
    }

    buildHeader(){
        let $row = $('<tr/>');

        for(var i in this.settings.columns){
            let column = this.settings.columns[i];
            $row.append(this.buildColumnHeader(column));
        }

        this.$tableHead.append($row);
    }

    buildColumnHeader(column){
        let $header = $('<th/>');

        $header
        .addClass('list-table-head-column')
        .addClass('list-table-head-column-'+column.name)
        .append(column.label);

        if(column.ordered){
            $header
            .addClass('list-table-head-column-ordered')
            .attr('data-order-type',column.orderType)
            .attr('data-order-dir',column.orderDir);

            this.orderBy = column.orderType;
            this.orderDir = column.orderDir;
        }

        if(column.class){
            $header.addClass(column.class);
        }

        return $header;
    }

    isGraphQLData(){
        return this.settings.graphQL === null ? false : true;
    }

    hasData(){
        return this.settings.data === null ? false : true;
    }

    initializeWithGraphQL(){
        this.first = this.length;
        this.loadData();
    }

    reset(){
        this.first = this.length;
        this.last = null;
        this.after = null;
        this.before = null;
        this.firstCursor = null;
    }

    refresh(){
        var self = this;
        //refresh after timeout to let filters inputs to be changed (like input text when user has not yet finished to type text)
        setTimeout(function(){
            self.reset();
            self.loadData();
        }, 300);
    }

    loadData(){
        if(this.isLoading){
            if(this.query){
                this.query.abort();
            }
        }

        this.drawLoader();
        this.isLoading = true;
        
        let parameters = null;
        if(typeof this.settings.graphQL.parameters === 'function'){
            parameters = this.settings.graphQL.parameters(this);
        }else{
            parameters = this.settings.graphQL.parameters;
        }

        //ordering
        if(!parameters.orderBy){
            parameters.orderBy = this.orderBy;
            parameters.dir = this.orderDir;
        }


        //pagination
        if(this.settings.hasEdges && this.first){
            parameters.first = this.first;
            if(this.after){
                parameters.after = this.after;
            }
        }
        if(this.settings.hasEdges && this.last){
            parameters.last = this.last;
            if(this.before){
                parameters.before = this.before;
            }
        }

        let attributes = {
            'queryType': this.settings.graphQL.queryType,
            'parameters': parameters,
            'fields': this.settings.graphQL.fields,

            'before': this.onLoadStart,
            'after': this.onLoadEnd,
            'error': this.onLoadFail,
            'success': this.onLoadComplete,

            'hasEdges': this.settings.hasEdges,
            'addPageInfo': this.settings.hasEdges,
            'addTotalCount': this.settings.hasEdges,
        };

        this.query = new GraphQLQuery(attributes);
        return this.query.execute();
    }

    initializeWithRawData(){
        let data = this.settings.data;
        if(this.settings.onLoadComplete){
            this.settings.onLoadComplete(data);
        }

        data = this.settings.preprocessData(data,this);

        this.drawBody(data);
        this.drawPagination(data.length,null);
        this.isLoading = false;
        this.data = data;
    }

    onLoadStart(){

        if(this.settings.onLoadStart){
            this.settings.onLoadStart();
        }

    }

    onLoadEnd(){

        if(this.settings.onLoadEnd){
            this.settings.onLoadEnd();
        }

    }

    onLoadComplete(data){
        this.rawData = data;
        if(this.settings.onLoadComplete){
            this.settings.onLoadComplete(data);
        }

        if(this.settings.hasEdges){
            if(data.edges){
                data = this.settings.preprocessData(data);
                this.data = data.edges;
                let pageInfo = data.pageInfo;
                let totalCount = data.totalCount;
                this.drawBody(this.data);
                this.drawPagination(totalCount,pageInfo);
            }else{
                window.notify("@todo implement ui/list/Table graphQL with no edges","warning");
            }
        }else{
            data = this.settings.getDataFromRawData(data);
            this.data = data.lines;
            let pageInfo = data.pageInfo;
            let totalCount = data.totalCount;
            this.drawBody(this.data);
            this.drawPagination(totalCount,pageInfo);

        }

        this.isLoading = false;
    }

    onLoadFail(message,data){
        if(this.settings.onLoadFail){
            this.settings.onLoadFail(message);
        }
    }

    drawPagination(totalCount,pageInfo){
        var self = this;

        this.$tableFoot.html('');

        if(this.settings.footerContent){
            this.$tableFoot.append(this.settings.footerContent);
        }else if(this.settings.footerBuilder){
            this.buildFooterBasedOnSettings();
        }

        if(!this.settings.showPagination || this.settings.length <= 0){
            return;
        }

        if(pageInfo){

            if(!this.firstCursor){
                this.firstCursor = pageInfo.startCursor;
            }

            let isFirst = false;
            let isEnd = false;

            let hasPreviousPage = pageInfo.hasPreviousPage || this.after;
            if(this.firstCursor == pageInfo.startCursor){
                isFirst = true;
                hasPreviousPage = false;
            }
            let hasNextPage = pageInfo.hasNextPage || this.before;
            if(!hasNextPage){
                isEnd = true;
            }

            let $pagination = $('<div/>')
            .addClass('d-flex justify-content-center mt-2')
            .addClass('list-table-pagination');

            let $firstPageButton = $('<button/>')
            .attr('type','button')
            .addClass('btn btn-dark list-table-pagination-start')
            .append(window.translate('start'));

            if(isFirst){
                $firstPageButton.attr('disabled','disabled');
            }else{
                $firstPageButton
                .attr('data-first',this.length)
                .on('click',function(event){
                    let $btn = $(this);
                    self.onClickPaginationButton($btn);
                });
            }


            let $previousPageButton = $('<button/>')
            .attr('type','button')
            .addClass('btn btn-dark list-table-pagination-previous')
            .append(window.translate('previous'));

            if(hasPreviousPage){

                $previousPageButton
                .attr('data-last',this.length)
                .attr('data-before',pageInfo.startCursor)
                .on('click',function(event){
                    let $btn = $(this);
                    self.onClickPaginationButton($btn);
                });
            }else{
                $previousPageButton.attr('disabled','disabled');
            }


            let $nextPageButton = $('<button/>')
            .attr('type','button')
            .addClass('btn btn-dark list-table-pagination-next')
            .append(window.translate('next'));

            if(hasNextPage){

                $nextPageButton
                .attr('data-first',this.length)
                .attr('data-after',pageInfo.endCursor)
                .on('click',function(event){
                    let $btn = $(this);
                    self.onClickPaginationButton($btn);
                });


            }else{
                $nextPageButton.attr('disabled','disabled');
            }


            let $lastPageButton = $('<button/>')
            .attr('type','button')
            .addClass('btn btn-dark list-table-pagination-end')
            .append(window.translate('end'));

            if(isEnd){
                $lastPageButton.attr('disabled','disabled');
            }else{
                $lastPageButton
                .attr('data-last',this.length)
                .on('click',function(event){
                    let $btn = $(this);
                    self.onClickPaginationButton($btn);
                });
            }

            $pagination
            .append($firstPageButton)
            .append('&nbsp;')
            .append($previousPageButton)
            .append('&nbsp;')
            .append($nextPageButton)
            .append('&nbsp;')
            .append($lastPageButton);


            let length = this.length;
            if(length > totalCount){
                length = totalCount;
            }
            let totalCountMessage = length + ' ' + window.translate('shownOn') + ' ' + totalCount;
            let $totalCount = $('<span/>')
            .addClass('list-table-totalcount')
            .append(totalCountMessage)

            this.$tableFoot.append(
                $('<tr/>')
                .append(
                    $('<td/>')
                    .attr('col-span','100')
                    .append($pagination)
                )
                .append(
                    $('<td/>')
                    .append($totalCount)
                )
            )
            if(length == totalCount){
                this.$tableFoot.html('');
            }
        }

    }

    onClickPaginationButton($btn){
        this.first = null;
        this.last = null;
        this.after = null;
        this.before = null;

        if($btn.data('first')){
            this.first = $btn.data('first');
        }
        if($btn.data('last')){
            this.last = $btn.data('last');
        }
        if($btn.data('after')){
            this.after = $btn.data('after');
        }
        if($btn.data('before')){
            this.before = $btn.data('before');
        }

        this.loadData();
    }

    drawLoader(){
        this.$tableBody.html('');
        this.$tableFoot.html('');


        let $loader = $('<tr/>')
        .append(
            $('<td/>')
            .attr('colspan',this.settings.columns.length)
            .append(window.App.generateLoader())
        )

        this.$tableBody.append($loader);
    }

    drawBody(data){        
        this.$tableBody.html('');
        if(data && data.length > 0){
            for(var i in data){
                if(!this.settings.length || i < this.settings.length){
                    let $line = this.buildBodyLine(data[i],i);
                    this.$tableBody.append($line);
                }
            }
        }else{
            let $line = this.buildEmptyLine();
            this.$tableBody.append($line);
        }

        if(this.settings.onDrawn){
            this.settings.onDrawn(this);
        }
    }

    buildEmptyLine(){
        let length = this.settings.columns.length;

        let $row = $('<tr/>')
        .append(
            $('<td/>')
            .attr('colspan',length)
            .append(
                $('<div/>')
                .addClass('d-flex justify-content-center')
                .append(this.settings.labelNoData)
            )
        );
        return $row;
    }

    buildBodyLine(item,index){
        let $row = $('<tr/>')
        .attr('id',this.settings.rowIdCallback(item));

        this.settings.onDrawLine($row,item,index);

        for(var col in this.settings.columns){
            let column = this.settings.columns[col];
            let $item = this.buildBodyItem(item,index,column);

            $row.append($item);
        }

        this.$tableBody.append($row);
    }

    buildBodyItem(item,index,column){
        let $item = $('<td/>');
        let $content = column.render(item,index,this);

        $item
        .addClass('list-table-body-item')
        .addClass('list-table-body-item-'+column.name)
        .append($content);
        if(column.class){
            $item.addClass(column.class);
        }
        return $item;
    }

    focus(rowId){
        var self = this;
        if(!this.isLoading){
            $('#'+rowId,this.$table).get(0).scrollIntoView({
                'behavior': 'auto',
                'block': 'center',
                'inline': 'center'
            });
        }else{
            setTimeout(function(){
                self.focus(rowId);
            },500);
        }
    }
    
    buildFooterBasedOnSettings(){
        let mode = this.settings.footerBuilder.mode;
        if(!mode){
            mode = 'full';
        }
        let renderCallback = this.settings.footerBuilder.render;

        let $footerContent = renderCallback(this.data,this);
        let $row = $('<tr/>');

        if (Array.isArray($footerContent)){
            for(var i in $footerContent){
                let $row = $footerContent[i];
                this.$tableFoot.append($row);
            }
        }else if(mode == 'full'){
            $row
            .append(
                $('<td/>')
                .attr('colspan',this.settings.columns.length)
                .append($footerContent)
            )
            this.$tableFoot.append($row);

        }else{
            this.$tableFoot.append($footerContent);
        }
    }
}

module.exports = Table;

